import React, { forwardRef } from 'react';

interface SearchInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onSearch?: (query: string) => void;
  onFocus?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
  placeholder = "Search anything or issue",
  value = "",
  onChange,
  onSearch,
  onFocus,
  onKeyDown,
  className = "",
  disabled = false
}, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  return (
    <div className={`relative flex-1 max-w-3xl ${className}`}>
      <input
        ref={ref}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={onFocus}
        disabled={disabled}
        className="w-full h-10 pl-4 pr-10 text-[14px] leading-[20px] font-['Arcadia_Text',system-ui,sans-serif] text-gray-700 bg-white border border-gray-200 rounded-lg focus:outline-none focus:border-[#4F46E5] focus:ring-0.5 focus:ring-[#4F46E5] disabled:opacity-50 disabled:cursor-not-allowed"
      />
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
  );
}); 